export const MS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const MS_IN_MINUTE = SECONDS_IN_MINUTE * MS_IN_SECOND;
export const ONE_HOUR_IN_MS = MINUTES_IN_HOUR * MS_IN_MINUTE;
export const TWELVE_HOURS_IN_MS = 12 * ONE_HOUR_IN_MS;
export const LIVE_TIMER_INTERVAL_MS = MS_IN_SECOND;

export const BID_ITEM_ACTION = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
};
